import { apiService } from "./api";
import { API_CONFIG, buildUrl } from "../config/api";

export interface ContactMessage {
    message_id: string;
    name: string;
    email: string;
    phone: string | null;
    subject: string;
    message: string;
    status: "NEW" | "READ" | "REPLIED" | "ARCHIVED";
    reviewed_by_user_id: string | null;
    reviewed_at: string | null;
    create_time: string;
    update_time: string;
}

export interface ContactMessageListResponse {
    items: ContactMessage[];
    total: number;
    unread_count: number;
    skip: number;
    limit: number;
}

class ContactMessageService {
    async getMessages(params?: {
        skip?: number;
        limit?: number;
        status?: string;
    }): Promise<ContactMessageListResponse> {
        const query = new URLSearchParams();
        if (params?.skip !== undefined)
            query.append("skip", String(params.skip));
        if (params?.limit !== undefined)
            query.append("limit", String(params.limit));
        if (params?.status) query.append("status", params.status);
        const qs = query.toString();
        const url = `${API_CONFIG.ENDPOINTS.CONTACT_MESSAGES.BASE}${qs ? `?${qs}` : ""}`;
        return apiService.get<ContactMessageListResponse>(url);
    }

    async getMessage(id: string): Promise<ContactMessage> {
        return apiService.get<ContactMessage>(
            `${API_CONFIG.ENDPOINTS.CONTACT_MESSAGES.BASE}/${id}`,
        );
    }

    async updateStatus(
        id: string,
        newStatus: ContactMessage["status"],
    ): Promise<ContactMessage> {
        const url = buildUrl(API_CONFIG.ENDPOINTS.CONTACT_MESSAGES.STATUS, {
            id,
        });
        return apiService.patch<ContactMessage>(url, { status: newStatus });
    }

    async deleteMessage(id: string): Promise<void> {
        await apiService.delete(
            `${API_CONFIG.ENDPOINTS.CONTACT_MESSAGES.BASE}/${id}`,
        );
    }
}

export const contactMessageService = new ContactMessageService();
